import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import ChatWindow from './ChatWindow';
import { useAppSelector } from 'src/rtk/app/hook';

const HIDE_ON_ADMIN_PATHS = true;
const ADMIN_PATH_PREFIX = '/admin';

const FloatingKbChatbot: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();
  const isAdminPath = location.pathname.startsWith(ADMIN_PATH_PREFIX);
  const hideWidget = HIDE_ON_ADMIN_PATHS && isAdminPath;
  const authUser = useAppSelector((state) => state.auth.user);

  if (hideWidget || authUser?.type === 'Operation') return null;

  return (
    <div className="chatbot-floating-wrapper">
      {isOpen && <ChatWindow onClose={() => setIsOpen(false)} />}
      <button
        type="button"
        className="chatbot-fab"
        onClick={() => setIsOpen((prev) => !prev)}
        aria-label={isOpen ? 'Close chat' : 'Open Knowledge Base chat'}
        title="Question & Answer"
      >
        <i className={isOpen ? 'fa-solid fa-times' : 'fa-solid fa-circle-question'} />
      </button>
    </div>
  );
};

export default FloatingKbChatbot;
